import { InjectionToken } from '@angular/core';

export const REQUEST_HEADERS = new InjectionToken<any>('REQUEST_HEADERS');

